import React from "react"
import './Button.scss'

/**
 * added spread props
 * @param {*} props 
 * @returns 
 */
const LinkButton = props =>{

    const { disabled = false } = props;
    return(
        <button className={`${props.className} nova-link-btn`} onClick={props.onClick} disabled={disabled}>
            <span className={`nova-btn-txt`}>
                { props.text }
            </span>
        </button>
    )
}

export default LinkButton;